













import { Component, Prop, Vue } from 'vue-property-decorator';
import Vertical from './vertical.vue';

@Component({
  components: {
    Vertical,
  },
})
export default class BlackListBanner extends Vue {
  @Prop() bannerConfigUrl!: string;
  @Prop() hottag!: string;
  @Prop() type!: string;
  @Prop({ default: '8px' }) marginBottom!: string;
  @Prop({ default: '4px' }) borderRadius!: string;
}
